import axiosIns from '@/api/axios'

export const GET_TRAINING_TYPE = (args) => {
    return axiosIns.get('/master-data/training-type', args)
}

